// Разводящая страница блога повторяет новости: те же поля карточки (hero)
// и та же пагинация по 6 штук
export const searchParams = {
  posts: {
    sort: ["createdAt:desc"],
    pagination: {
      page: 1,
      pageSize: 6,
    },
    populate: {
      hero: {
        populate: {
          author: { populate: "*" },
          mainImage: { populate: "*" },
        },
      },
    },
  },
  page: {
    populate: {
      titleWithIcon: {
        populate: {
          titleIconSettings: {
            populate: {
              icon: {
                populate: {
                  uicon: {
                    populate: "*",
                  },
                  icon: {
                    populate: "*",
                  },
                },
              },
            },
          },
        },
      },
      seo: {
        populate: {
          ogImage: {
            populate: "*",
          },
        },
      },
    },
  },
};
